import React from 'react';
import SectionTitle from './SectionTitle';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';

const Section5Title = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const title = (
    <>
      <span>{context.sectionNumbers.section5}</span>
      <span>. תאור הסביבה</span>
    </>
  );

  return <SectionTitle title={title} ref={ref}/>;
});

export default Section5Title;
